import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import theme from '../../theme/theme';

const {
  Icons: {
    general: { ArrowRight },
  },
} = theme;

const ArrowNext = ({ classes }) => (
  <img src={ArrowRight} className={classes.icon__color} alt="Icon" />
);

ArrowNext.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ArrowNext);
